import React, {useState} from 'react';
import {Checkbox, FormControlLabel} from "@mui/material";
const QuarterAnalysis = ({index, label}) => {
    return (
    <div>

      <div className={'flex justify-end text-white text-sm font-light bg-dark-light p-1'}>{2023 - (index + 1)}</div>
    <div className={'bg-d-gray border-b-2 border-gray-800 text-white text-sm font-light '} key={index}>
                      {Array.from({ length: 4 }, (_, indexKey) => <FormControl label={label} index={index} indexKey={indexKey}/> )}
    </div>

      </div>
    )
}
const FormControl = ({label, index, indexKey})=>{
        const [checked, setChecked] = useState(false);
    return <div className={'w-100 border-b-2 border-gray-800 px-2 py-1 cursor-pointer'} onClick={() => setChecked(!checked)}><FormControlLabel
                              control={<Checkbox sx={{
                                  color: 'white',
                                  marginRight: '10px',
                              }} checked={checked} />}
                              label={label && label.includes("Earnings") ? label + ` Q${indexKey+1} ${2023 - (index + 1)}` : label}
                          /></div>
}
export default QuarterAnalysis;